import {
  FETCH_WHATSAPP_TEMPLATE_LIST_REQUEST,
  FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS,
  FETCH_WHATSAPP_TEMPLATE_LIST_FAILURE
} from '../../constants/ActionTypes';

const initialState = {
  whatsappTemplates: [],
  loading: false,
  error: null
};

const whatsappTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch WhatsApp Templates List
    case FETCH_WHATSAPP_TEMPLATE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        whatsappTemplates: action.payload,
        error: null
      };
    
    case FETCH_WHATSAPP_TEMPLATE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Failed to fetch WhatsApp templates'
      };

    default:
      return state;
  }
};

export default whatsappTemplateReducer;
